import React from 'react';
import Head from 'next/head';
import {
  HomeBusinessOrganism,
  HomeOurProductsOrganism,
  HomeWhyPartnerOrganism,
  HomeHeroOrganism,
  PartnerFormOrganism,
  HeaderTemplate,
} from '../components';
import { heroHome } from '../enums/homepage/hero';
import { homeContent } from '../enums/homepage';
import { productLinks } from '../enums';

const Index = (): any => {
  return (
    <>
      <Head>
        <title>{homeContent.TITLE}</title>
      </Head>
      <HeaderTemplate
        links={productLinks}
        addClass="bg-waldo-hero-two lg:bg-white"
      />
      <main role="main">
        <HomeHeroOrganism heroContent={heroHome} />
        <HomeWhyPartnerOrganism
          title={homeContent.WHY_PARTNER_US.TITLE}
          button={homeContent.CTA}
          content={homeContent.WHY_PARTNER_US.CONTENT}
        />
        <HomeBusinessOrganism cta={homeContent.CTA} />
        <HomeOurProductsOrganism />
        <PartnerFormOrganism title="Contact" buttonLabel="SEND" />
      </main>
    </>
  );
};

export default Index;
